import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
const SearchInput = ({
  searchTag,
  searchTerm,
  handleChange,
  dir,
  searchTagPashto,
  searchTagUrdu,
}) => {
  return (
    <div>
      <Box
        component="form"
        sx={{
          "& > :not(style)": { m: 1, width: "25ch" },
        }}
        noValidate
        autoComplete="off"
        style={{ direction: dir }}
      >
        <TextField
          id="standard-basic"
          label={searchTag || searchTagPashto || searchTagUrdu}
          variant="standard"
          style={{ width: "80%" }}
          value={searchTerm}
          onChange={handleChange}
        />
      </Box>
    </div>
  );
};

export default SearchInput;
